import get from 'lodash/get';
import {SET_CATEGORY, SET_SEARCH_TERM} from "~/actions/help_actions";
import {CHANGE_APP_PAGE} from "~/actions/actions";
import {reduceHelpData} from "~/rx/helpData";
import {modify} from "mythil/object";
import {helpInitialState} from "~/config";


export default function reduceHelp(state, action) {
    state = modify(state, 'helpData', (helpData) => reduceHelpData(helpData, action));

    switch(action.type) {
        case CHANGE_APP_PAGE:
            (() => {
                if(action.appPage !== 'help') { return state; }

                let category = get(action.data, 'params.category'),
                    forceChangeRootModel = get(action.data, 'options.forceChangeRootModel', false);

                if(forceChangeRootModel) {
                    state = {
                        ...helpInitialState,
                        helpData: state.helpData,
                    };
                }

                let mediaCategory = get(action.data, 'hash', '').substring(1);

                state = { ...state, category, mediaCategory };
            })();
            break;
        case SET_SEARCH_TERM:
            state = { ...state, term: action.term };
            break;
        case SET_CATEGORY:
            state = { ...state, category: action.category };
            break;
    }

    return state;
}